// extracted by mini-css-extract-plugin
module.exports = {"Container":"IconWithText-Container-1sYeeu","UnderlinedContainer":"IconWithText-UnderlinedContainer-31aQxo IconWithText-Container-1sYeeu","Text":"IconWithText-Text-2ODsX_"};